import React from 'react';

const Admin: React.FC = () => {
  return (
    <div>
      <h2>Admin Page</h2>
      <p>Welcome to the Admin panel!</p>
    </div>
  );
};

export default Admin;
